module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8BAMAAADI0sRBAAAAElBMVEUAAAAdr1cdr1cdr1cdr1cdr1eE3CTdAAAABXRSTlMAceTdbM+RLxUAAAB3SURBVDjL7cuxCYBAAATBEyzAxAbsQGzgESxA0P5b8THwgsUr4PlNl1GvsfYFbV+rxjs0Scf/PSWNEVeecOURmxODE5sTvw0RS3PA5sDgwObE5sDkxObE5MbgwOTE5JeUeMEyNwYHJjcmBwY3FnnElVeceFGv5R5Uy49c+WpvrgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/home/down_selected_icon.png
// module id = 167
// module chunks = 0